import { AuthIDTokenSupplierFactory } from "../auth/AuthIDTokenSupplierFactory";
import ClientLoggerFactory from "../logging/ClientLoggerFactory";
import CounterAdoptingSerialNumberGenerator from "./CounterAdoptingSerialNumberGenerator";
import { GraphQLAPI } from "@aws-amplify/api-graphql";
import SerialNumberGenerator from "./SerialNumberGenerator";

export default class CounterAdoptingSerialNumberGeneratorFactory {
    private static readonly INSTANCE: SerialNumberGenerator = new CounterAdoptingSerialNumberGenerator(
        ClientLoggerFactory.getClientLogger("CounterAdoptingSerialNumberGenerator"),
        GraphQLAPI,
        AuthIDTokenSupplierFactory.getInstance()
    );

    public static getInstance(): SerialNumberGenerator {
        return CounterAdoptingSerialNumberGeneratorFactory.INSTANCE;
    }
}
